import React, { useEffect, useRef, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Stack } from '@mui/material';
import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import JumboDemoCard from '@jumbo/components/JumboDemoCard';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { LoadingButton } from '@mui/lab';
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import './ledgerMas.css'

const LedgerMas = () => {
  const [disbleButton, setDisbleButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [Headdata, setHeadData] = useState(null);
  const swal =useSwalWrapper()
  // [
  //   { "id":1, "GROUP_TYPE": "ASSETS", "GROUP_NAME": "Cash and Cash Equivalents", "ORD": 1 },
  //   { "id":2, "GROUP_TYPE": "ASSETS", "GROUP_NAME": "Accounts Receivable", "ORD": 2 },
  //   { "id":3, "GROUP_TYPE": "LIABILITY", "GROUP_NAME": "Accounts Payable", "ORD": 3 },
  //   { "id":4,"GROUP_TYPE": "INCOME", "GROUP_NAME": "Sales Revenue", "ORD": 4 },
  //   { "id":5,"GROUP_TYPE": "EXPENSE", "GROUP_NAME": "Operating Expenses", "ORD": 5 },
  //   { "id":6,"GROUP_TYPE": "INCOME", "GROUP_NAME": "Other Income", "ORD": 6 }
  // ]
  // let Group_Type_value_opt=['LIABILITY', 'ASSETS', 'INCOME', 'EXPENSE']
  // useEffect(()=>{
  //   console.log(data)
  // },[data])
  const fetchHeadDetail = async()=>{
    data && setData(null)
    setDisbleButton(true)
    
    await jwtAuthAxios.get('/acc/leagerMaster').then(async res =>{
      let NEWDaTA= await res.data.ledger.map(led => ({...led,OPBAL:Math.abs(led.OPBAL),Type: led.OPBAL < 0 ? `CR.` : `DR.`}))
      setData(NEWDaTA)
      setHeadData(res.data.head)
      setDisbleButton(false)
    }).catch(r=>swal.fire({
      icon: 'error',
      text: 'Internal server Error',
    }))
  }
  useEffect(fetchHeadDetail,[])
  const columns = [
    { field: "GROUP_TYPE", headerName: "Group Type",width:((window.innerWidth-90)*10)/100},
    { field: "ACH_NAME", headerName: "Ledger Head",flex:1,width:((window.innerWidth-90)*72)/100,type: 'singleSelect', valueOptions:Headdata ? Headdata.map(m=>m.ACH_NAME):[],renderCell:(params)=>Headdata&& Headdata.find(m=>m.ACH_CODE ==params.row.ACH_CODE).ACH_NAME,editable:true},
    { field: "ANAME", headerName: "Name of Ledger",width:((window.innerWidth-90)*25)/100, type: 'text',editable: true},
    { field: "SHORT", headerName: "Short",width:100, type: 'text',editable: true},
    { field: "OPBAL", headerName: "OP.BAl", editable: true,width:((window.innerWidth-90)*10)/100,type: "number" },
    { field: "Type", headerName: "Type", editable: true,width:((window.innerWidth-90)*10)/100,type: 'singleSelect', valueOptions:['CR.','DR.'] },
    { 
      field: 'ACTIVE', 
      headerName: 'Active', 
      width: 120, 
      renderCell: (params) => {
        return <Checkbox defaultChecked={params.value == 'Y'} id={'ch'+params.id} onClick={(e)=>{
          setTimeout(async() => {
            // console.log(e.target.checked);
            setData(()=> data.map( (row) => row.ACODE === params.row.ACODE ?  { ...row, ['ACTIVE']: e.target.checked?'Y':'N' }: row));
          }, 100);
        }
        } />;
      },
      // renderEditCell: (params) => {
      //   return <Checkbox checked={params.value} onChange={(e) => params.api.setEditCellValue(params.id, params.field, e.target.checked)} />;
      // }
    }
  ];
  const addnewRow =()=>{
    setData([{ "ACODE":`NEW-${(data?.length||0)+1}`,GROUP_TYPE: "ASSETS", "ACH_NAME": Headdata[0].ACH_NAME, "ANAME":'', "SHORT":'',"P_CODE":null,"OPBAL":'',"Type":null,ACH_CODE:Headdata[0].ACH_CODE,ACTIVE:'Y',Edited:true,NEW:true},...data]) 
  }
  const handleEditCellChangeCommit = (params) => {
    const updatedData = data.map((row) =>
      row.id === params.id ? { ...row, [params.field]: params.props.value } : row
    );
    setData(updatedData);
  };
  const apiRef = useRef();

  const handleButtonClick = async (props) => {
    // Get all promises for updating rows
    // if(props.id > 10000 && props.row.P_CODE != null){
    //   alert('field is not editable')
    //   setData(data);
    //   setDisbleButton(false)
    //   return
    // }
    setTimeout(async()=>{
      // console.log( );
    // if( (props.id > 10000 || props.row.P_CODE) && (props.field != 'SHORT' && props.field != 'ANAME' && props.field != 'ACH_NAME')) {
      const updatedRows = await Promise.all(
        data.map(async (row) => {
          if (row.ACODE === props.id ) {
            const updatedCellValue = await apiRef.current.getCellValue(props.id, props.field);
            // console.log(Headdata.find(m=>m.ACH_NAME == updatedCellValue));
            if(props.field == 'ACH_NAME'){
              return { ...row, ACH_CODE: Headdata.find(m=>m.ACH_NAME == updatedCellValue).ACH_CODE,GROUP_TYPE:Headdata.find(m=>m.ACH_NAME == updatedCellValue).GROUP_TYPE,Edited:true };
            }else{
              return { ...row, [props.field]: updatedCellValue,Edited:true };
            }
          }
          return row;
        })
        );
        // console.log(updatedRows);
        setData(updatedRows);
        setDisbleButton(false)
      // }
      },100);
    // Update the state or perform other operations with updatedRows
  };
  
  const saveDataHandler= async()=>{
    setLoading(false)
    let FrmData = await data.filter(s=> s.Edited == true)
    await jwtAuthAxios.post('/acc/leagerMaster',{"leagers":FrmData}).then(res=>{
      swal.fire({
        icon: 'success',
        text: res.data.message,
      });
      setData([])
      // setHeadData([])
      fetchHeadDetail()
    }).catch(e => {
      swal.fire({
        icon: 'error',
        text: 'Internal server Error',
      });    
      }).finally(e=>{
        setLoading(false)
      });    
  }
  const Disabled_edit_row = {
    opacity: '0.7',
    pointerEvents: 'none'
  }

  return (
    <JumboCardQuick  action={<Stack direction={"row"} justifyContent={'end'} spacing={2}><Button variant='contained' onClick={addnewRow}>Add new</Button><LoadingButton disabled={disbleButton} loading={loading} variant='contained' onClick={saveDataHandler}>Save</LoadingButton></Stack>} sx={{p:0}} title={'Ledger Master'} >

    <Paper elevation={0} sx={({backgroundColor: theme => theme.palette.action.hover,p:0})}>
      {!Boolean(data) ? <TableSkeleton/>: <DataGrid
          rows={data||[]}
          columns={columns}
          pageSize={5}
          apiRef={apiRef}
          density='compact'
          getRowId={(row) => row.ACODE}
          rowsPerPageOptions={[50, 100, 200]}
          sx={{p:0,fontSize:'16px'}}
          getCellClassName={(params) =>{console.log(params?.row['NEW']);
            return((params.field === 'GROUP_TYPE' || params.field === 'ACH_NAME' || params.field === 'ANAME' || params.field === 'SHORT') && (((params.id < 10000 || !params?.row['NEW'] && params?.row['P_CODE'])))) ? 'Disabled_edit' : ''
          }
          }
          // getRowClassName={(params) =>
          //   ((params.field === 'GROUP_TYPE' || params.field === 'ACH_NAME' || params.field === 'ANAME' || params.field === 'SHORT') && ((params.id > 10000 || params?.row?.NEW == true) && params.row.P_CODE != null)) ? 'disabled-row' : ''
          // }
          // isCellEditable={(params) => {
          //   return (((params.id > 10000 || params?.row?.NEW == true) || params.row.P_CODE == null)|| (params.field === 'Type' || params.field === 'OPBAL')); // Example condition
          // }}
        
          onCellEditStart={(pams)=>setDisbleButton(true)}
          onCellEditStop={handleButtonClick}
          disableRowSelectionOnClick
          />}
    </Paper>
    </JumboCardQuick>

  );
};
LedgerMas.Modulename = 'LedgerMas';


export default LedgerMas;

